import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../../atoms/Grid/Grid';
import './BasePage.scss';

const BasePage = ({
  children,
}) => (
  <div className="base-page-container">
    <Grid>
      {children}
    </Grid>
  </div>
);

BasePage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BasePage;
